import { FormType } from '../../../form-types';
import { TestosteroneSupportEdQuestionFieldAnswers } from '../questions';

export const testosteroneSupportEd: FormType<TestosteroneSupportEdQuestionFieldAnswers> =
{
  name: 'Testosterone Support Ed',
  questions: [
    {
      key: 'testosteroneSupportEd_sexAssignedAtBirth',
      next: {
        condition: {
          'testosteroneSupportEd_sexAssignedAtBirth.male': true
        },
        key: 'testosteroneSupportEd_height',
        els: 'testosteroneSupportEd_ineligible'
      }
    },
    'testosteroneSupportEd_height',
    'testosteroneSupportEd_weight',
    {
      key: 'testosteroneSupportEd_physicalExam',
      next: {
        condition: {
          'testosteroneSupportEd_physicalExam.yes_problems': true
        },
        key: 'testosteroneSupportEd_physicalExam_issues',
        els: 'testosteroneSupportEd_hospitalizations'
      }
    },
    'testosteroneSupportEd_physicalExam_issues',
    {
      key: 'testosteroneSupportEd_hospitalizations',
      next: {
        condition: { 'testosteroneSupportEd_hospitalizations.yes': true },
        key: 'testosteroneSupportEd_hospitalizations_details',
        els: 'testosteroneSupportEd_conditions'
      }
    },
    'testosteroneSupportEd_hospitalizations_details',
    {
      key: 'testosteroneSupportEd_conditions',
      next: {
        condition: { 'testosteroneSupportEd_conditions.none': true },
        key: 'testosteroneSupportEd_symptoms',
        els: 'testosteroneSupportEd_conditions_details'
      }
    },
    'testosteroneSupportEd_conditions_details',
    {
      key: 'testosteroneSupportEd_symptoms',
      next: {
        condition: { 'testosteroneSupportEd_symptoms.none': true },
        key: 'testosteroneSupportEd_previousTreatment',
        els: 'testosteroneSupportEd_symptomsDetails'
      }
    },
    'testosteroneSupportEd_symptomsDetails',
    'testosteroneSupportEd_symptomsDuration',
    {
      key: 'testosteroneSupportEd_previousTreatment',
      next: {
        condition: { 'testosteroneSupportEd_previousTreatment.yes': true },
        key: 'testosteroneSupportEd_treatmentDetails',
        els: 'testosteroneSupportEd_polycythemia'
      }
    },
    'testosteroneSupportEd_treatmentDetails',
    {
      key: 'testosteroneSupportEd_previousComplications',
      next: {
        condition: {
          'testosteroneSupportEd_previousComplications.yes': true
        },
        key: 'testosteroneSupportEd_previousSideEffects',
        els: 'testosteroneSupportEd_polycythemia'
      }
    },
    'testosteroneSupportEd_previousSideEffects',
    {
      key: 'testosteroneSupportEd_polycythemia',
      next: {
        condition: { 'testosteroneSupportEd_polycythemia.yes': true },
        key: 'testosteroneSupportEd_ineligible',
        els: 'testosteroneSupportEd_hypertension'
      }
    },
    {
      key: 'testosteroneSupportEd_hypertension',
      next: {
        condition: { 'testosteroneSupportEd_hypertension.yes': true },
        key: 'testosteroneSupportEd_bpControlled',
        els: 'testosteroneSupportEd_tobacco'
      }
    },
    {
      key: 'testosteroneSupportEd_bpControlled',
      next: {
        condition: { 'testosteroneSupportEd_bpControlled.no': true },
        key: 'testosteroneSupportEd_ineligible',
        els: 'testosteroneSupportEd_averageBP'
      }
    },
    'testosteroneSupportEd_averageBP',
    {
      key: 'testosteroneSupportEd_tobacco',
      next: {
        condition: { 'testosteroneSupportEd_tobacco.yes': true },
        key: 'testosteroneSupportEd_tobaccoFrequency',
        els: 'testosteroneSupportEd_alcohol'
      }
    },
    'testosteroneSupportEd_tobaccoFrequency',
    {
      key: 'testosteroneSupportEd_alcohol',
      next: {
        condition: { 'testosteroneSupportEd_alcohol.yes': true },
        key: 'testosteroneSupportEd_alcoholFrequency',
        els: 'testosteroneSupportEd_exercise'
      }
    },
    'testosteroneSupportEd_alcoholFrequency',
    'testosteroneSupportEd_exercise',
    'testosteroneSupportEd_contraindications',
    {
      key: 'testosteroneSupportEd_peyroniesDisease',
      next: {
        condition: { 'testosteroneSupportEd_peyroniesDisease.yes': true },
        key: 'testosteroneSupportEd_activeBending',
        els: 'testosteroneSupportEd_painWithErection'
      }
    },
    {
      key: 'testosteroneSupportEd_activeBending',
      next: {
        condition: { 'testosteroneSupportEd_activeBending.yes': true },
        key: 'testosteroneSupportEd_ineligible',
        els: 'testosteroneSupportEd_painWithErection'
      }
    },
    {
      key: 'testosteroneSupportEd_painWithErection',
      next: {
        condition: { 'testosteroneSupportEd_painWithErection.yes': true },
        key: 'testosteroneSupportEd_ineligible',
        els: 'testosteroneSupportEd_tightForeskin'
      }
    },
    {
      key: 'testosteroneSupportEd_tightForeskin',
      next: {
        condition: { 'testosteroneSupportEd_tightForeskin.yes': true },
        key: 'testosteroneSupportEd_ineligible',
        els: 'testosteroneSupportEd_cardiovascularSymptoms'
      }
    },
    'testosteroneSupportEd_cardiovascularSymptoms',
    {
      key: 'testosteroneSupportEd_illicitDrugUse',
      next: {
        condition: { 'testosteroneSupportEd_illicitDrugUse.other': true },
        key: 'testosteroneSupportEd_illicitDrugOtherDetails',
        els: 'testosteroneSupportEd_additionalInfo'
      }
    },
    'testosteroneSupportEd_illicitDrugOtherDetails',
    'testosteroneSupportEd_additionalInfo',
    {
      key: 'testosteroneSupportEd_consentTruthfulness',
      next: {
        condition: {
          'testosteroneSupportEd_consentTruthfulness.non_consent': true
        },
        key: 'testosteroneSupportEd_didNotConsent',
        els: 'testosteroneSupportEd_consentTreatment'
      }
    },
    {
      key: 'testosteroneSupportEd_consentTreatment',
      next: {
        condition: {
          'testosteroneSupportEd_consentTreatment.non_consent': true
        },
        key: 'testosteroneSupportEd_didNotConsent',
        els: 'testosteroneSupportEd_complete'
      }
    },
    'testosteroneSupportEd_complete',
    'testosteroneSupportEd_didNotConsent',
    'testosteroneSupportEd_ineligible'
  ]
};
